import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ISuccessSingleResponse } from '@shared/models/success-single-response';
import { Observable } from 'rxjs';
import {
  IJobsResponse,
  IParticipant,
  INotificationSendRequest,
  INotificationSendResponse,
  IEstadoCuentaRequest,
  IEstadoCuentaSendData,
  IJobStatus,
  INotificationSendV2Data,
} from '../models/notification-send';

@Injectable({
  providedIn: 'root',
})
export class NotificationSendService {
  private baseUrl: string = environment.SMART_API_URL;
  private readonly http: HttpClient = inject(HttpClient);

  getJobs(limit: number = 5): Observable<ISuccessSingleResponse<IJobsResponse>> {
    const getJobsUrl: string = `${this.baseUrl}notifications/jobs?limit=${limit}`;
    const response: Observable<ISuccessSingleResponse<IJobsResponse>> =
      this.http.get<ISuccessSingleResponse<IJobsResponse>>(getJobsUrl);

    return response;
  }

  getParticipants(fundId: string): Observable<ISuccessSingleResponse<IParticipant[]>> {
    const getParticipantsUrl: string = `${this.baseUrl}notifications/${fundId}/participants`;
    const response: Observable<ISuccessSingleResponse<IParticipant[]>> =
      this.http.get<ISuccessSingleResponse<IParticipant[]>>(getParticipantsUrl);

    return response;
  }

  sendNotification(
    notificationData: INotificationSendRequest
  ): Observable<INotificationSendResponse> {
    const sendNotificationUrl: string = `${this.baseUrl}notifications/send`;
    const response: Observable<INotificationSendResponse> = this.http
      .post<INotificationSendResponse>(sendNotificationUrl, notificationData);

    return response;
  }

  sendEstadoCuenta(
    data: IEstadoCuentaRequest
  ): Observable<ISuccessSingleResponse<IEstadoCuentaSendData>> {
    const url: string = `${this.baseUrl}notifications/send-estado-cuenta`;
    return this.http.post<ISuccessSingleResponse<IEstadoCuentaSendData>>(url, data);
  }

  sendNotificationV2(
    fields: INotificationSendRequest,
    files: File[] = [],
  ): Observable<ISuccessSingleResponse<INotificationSendV2Data>> {
    const formData = new FormData();
    formData.append('messageId', String(fields.messageId));
    formData.append('fundId', fields.fundId);
    formData.append('subject', fields.subject);
    formData.append('receiverType', fields.receiverType);
    fields.identification.forEach((id) => formData.append('identification', id));
    if (fields.receiverType === 'Email') {
      files.forEach((file) => formData.append('adjuntos', file, file.name));
    }
    return this.http.post<ISuccessSingleResponse<INotificationSendV2Data>>(
      `${this.baseUrl}notifications/send/v2`,
      formData,
    );
  }

  getJobStatus(jobId: number): Observable<ISuccessSingleResponse<IJobStatus>> {
    const url: string = `${this.baseUrl}notifications/jobs/${jobId}`;
    return this.http.get<ISuccessSingleResponse<IJobStatus>>(url);
  }
}
